/* Local prices. The payment gateway (iyzico) only supports one currency, so checkout stays in USD;
   this script shows local amounts for the visitor's country at the daily ECB rate and states the USD charge once, under the price. */
(() => {
  const __t = window.__t || (s => s);
  const EU = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' ');
  const country = window.NL_COUNTRY || '';
  const currency = country === 'TR' ? 'TRY' : country === 'GB' ? 'GBP' : country === 'CA' ? 'CAD' : EU.includes(country) ? 'EUR' : null;
  if (!currency) return;
  const locale = { TRY: 'tr-TR', GBP: 'en-GB', CAD: 'en-CA', EUR: 'de-DE' }[currency];
  const CACHE = 'nl-rates-v1', MAX_AGE = 12 * 3600 * 1000;

  async function rates() {
    try {
      const cached = JSON.parse(localStorage.getItem(CACHE) || 'null');
      if (cached && Date.now() - cached.at < MAX_AGE) return cached.rates;
    } catch {}
    const response = await fetch('https://api.frankfurter.dev/v1/latest?base=USD&symbols=TRY,GBP,EUR,CAD');
    if (!response.ok) throw new Error('rates');
    const data = await response.json();
    try { localStorage.setItem(CACHE, JSON.stringify({ at: Date.now(), rates: data.rates })); } catch {}
    return data.rates;
  }

  const usd = text => {
    const match = String(text).replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return match ? parseFloat(match[0]) : null;
  };

  function render(rate) {
    const format = new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: 0 });
    document.querySelectorAll('[data-nl-money]:not([data-nl-done])').forEach(el => {
      const amount = usd(el.textContent);
      if (amount === null) return;
      const original = el.textContent.trim();
      el.dataset.nlDone = '';
      el.title = __t('Charged in USD') + ': ' + original;
      const local = format.format(Math.round(amount * rate));
      if (el.tagName === 'S') { el.textContent = local; return; }
      el.innerHTML = '';
      el.append(local);
      const small = document.createElement('span');
      small.className = 'nl-usd';
      small.textContent = original;
      el.append(small);
    });
    const note = document.createElement('p');
    note.className = 'nl-currency-note';
    const product = document.querySelector('.pd-price'), cart = document.querySelector('[data-nl-note]')?.closest('.cart-summary');
    const charged = product?.querySelector('[data-product-price] .nl-usd')?.textContent;
    note.textContent = product && charged
      ? __t("You'll be charged {usd} at checkout. Price shown at today's exchange rate.").replace('{usd}', charged)
      : __t("Payment is taken in USD at checkout. Prices shown at today's exchange rate.");
    if (product && !document.querySelector('.nl-currency-note')) product.after(note);
    else if (cart && !cart.querySelector('.nl-currency-note')) cart.append(note);
  }

  const run = () => rates().then(r => { if (r && r[currency]) render(r[currency]); }).catch(() => {});
  run();
  // Prices added after load (live search results) ask for another pass; rates come from the cache.
  document.addEventListener('nl:money', run);
})();
